export default function isFromTrainingCdnSrcImageUtil (src) {
  if (!src) {
    return false
  }
  return src.includes('cdn-training.gymaholic.co')
}
